module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-action"
  }, [(this.$slots['note']) ? _c('div', {
    staticClass: "cb-note"
  }, [_vm._t("note", null, {
    slot: "content"
  })], 2) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "cb-button",
    class: [_vm.deriveClass, {
      'cb-button__disabled': _vm.btnDisabled
    }],
    style: (!_vm.btnDisabled && [_vm.backgroundColor, _vm.themeColor]),
    attrs: {
      "aria-disabled": _vm.btnDisabled,
      "disabled": _vm.btnDisabled || _vm.showLoader,
      "data-cb-id": _vm.attr
    },
    on: {
      "click": function($event) {
        _vm.next($event)
      },
      "keyup": _vm.enter
    }
  }, [_c('span', {
    staticClass: "cb-button__text"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (this.$slots['warning']) ? _c('div', {
    staticClass: "cb-note",
    class: 'cb-note__warning'
  }, [_vm._t("warning")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-847a61a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/form/ButtonComponent.vue
// module id = 119
// module chunks = 66 67 68 69